import GraphRanges from "@/mixins/GraphRanges";
import { Patient } from "@/store/modules/patient/types";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";
import Util from "../shared/util";

const patientNamespace = { namespace: "patient" };
@Component({})
export default class Qsofa extends mixins(GraphRanges) {
  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  get charts(): MultiChartConfig[] {
    return [
      {
        title: "QSOFA",
        data: this.graph(["QSOFA"]),
        suggestedMax: 3
      }
    ];
  }

  get scores() {
    const [bpSys, lungRate, GCS] = this.current.body.atoms.qSofa.legend.split(
      ","
    );
    return { bpSys, lungRate, GCS };
  }

  get bpSys() {
    const value = this.current.body.atoms.bpSys.value || "N/A";
    const color = Util.getLevelTableColor(this.scores.bpSys as any);
    return { value, color };
  }

  get lungRate() {
    const value = this.current.body.atoms.lungRate.legend || "N/A";
    const color = Util.getLevelTableColor(this.scores.lungRate as any);
    return { value, color };
  }

  get GCS() {
    const value = this.current.body.current.GCS.text || "N/A";
    const color = Util.getLevelTableColor(this.scores.GCS as any);
    return { value, color };
  }
}
